<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- GO BACK BUTTON -->
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="goBack()"></button>
    </ng-template>
</p-toolbar>

<!-- MAIN SCREEN -->
<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_item}}:</span>
                    <span class="p-text-bold">{{itemId}} - {{item!=null && item.descrip!=null?item.descrip:""}}
                    </span>
                </div>
            </p-panel>
        </div>
    </div>
    <p-table #dt [value]="lstItemsAlbum" [globalFilterFields]="['descrip']" [rowHover]="true" dataKey="id"
        styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">

                <h5 class="p-m-0"> {{translations.lbl_manuals_tutorials}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width:5rem" pSortableColumn="sequence">{{translations.lbl_id}}<p-sortIcon field="sequence">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="descrip">{{translations.lbl_name}}<p-sortIcon field="descrip">
                    </p-sortIcon>
                </th>
                <th>{{translations.lbl_select}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.id.seqDt1}}</td>
                <td>{{value.descrip}}</td>

                <td>
                    <button type="button" pButton pRipple icon="pi pi-search"
                        (click)="selectRecord(value.id.seqDt1)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{lstItemsAlbum ? lstItemsAlbum.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>